import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Input from '../Input/Input';
import FormSection from '../FormSection/FormSection';
import FormHalfCol from '../FormHalfCol/FormHalfCol';
import Select from '../Select/Select';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import FinancialInstitutionSelect from '../FinancialInstitutionSelect/FinancialInstitutionSelect';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import { getDealers, getOccupations, sendPreApprovalRequest } from './Utils';
import { Context } from '../Context/withContext';
import rawEmployerCodes from '../../employerTypeCode.json';
import axios from 'axios';

const schema = yup.object().shape({
  current_bank_personal_bank: yup.string().required('Required'),
  account_type: yup.string().required('Required'),
  occupation: yup.string().required('Required'),
  industry: yup.string().required('Required'),
  name_of_employer: yup
    .string()
    .max(40, 'Cannot be longer than 40 characters')
    .required('Required'),
  years_at_work: yup
    .number()
    .min(0, 'Cannot be less than 0')
    .required('Required'),
  months_at_work: yup.number().min(0).max(11).required('Required'),
  select_province: yup.string().required('Required'),
  preferred_suzuki_dealer_dealership: yup.string().required('Required'),
});

const VehiclePart5 = ({ loading, setLoading, setError }) => {
  const [formData, setFormData] = useContext(FormDataContext);
  const [stepNumber, setStepNumber] = useContext(Context);

  const [occupations, setOccupations] = React.useState([]);
  const [provinces, setProvinces] = React.useState({});
  const [dealersByProvince, setDealersByProvince] = React.useState({});
  const [formattedEmployerCodes, setFormattedEmployerCodes] = React.useState({});
  const [selectedProvince, setSelectedProvince] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    getOccupations()
      .then((occupations) => {
        setOccupations(occupations);
        const temp = {};
        rawEmployerCodes.forEach((item) => {
          temp[item.CODE] = item.DESCRIPTION;
        });
        setFormattedEmployerCodes(temp);
      })
      .catch((e) => console.log(e));

    // Fetch dealers from the new endpoint
    axios.get('https://us-central1-fasttrack-client.cloudfunctions.net/api/dealers-all')
      .then((response) => {
        const dealers = response.data;
        
        // Create a unique list of provinces
        const uniqueProvinces = [...new Set(dealers.map(dealer => dealer.province))].sort();
        const provinceOptions = {};
        uniqueProvinces.forEach(province => {
          provinceOptions[province] = province;
        });
        
        // Group dealers by province
        const dealerGroups = {};
        dealers.forEach(dealer => {
          if (!dealerGroups[dealer.province]) {
            dealerGroups[dealer.province] = {};
          }
          dealerGroups[dealer.province][dealer.value] = dealer.label;
        });
        
        setProvinces(provinceOptions);
        setDealersByProvince(dealerGroups);
      })
      .catch((e) => console.log(e));
  }, []);

  const onSubmit = async (data) => {
    console.log('^^^DATA:', data);
    setLoading(true);
    let reqData = {};
    reqData.customerProfile = formData.customerProfile;
    reqData.customerProfile.customerType =
      formData.customerProfile.occupation.customerType;
    delete reqData.customerProfile.occupation;
    reqData.income = formData.income;
    reqData.asset = formData.asset;
    reqData.asset.makeCode = reqData.asset.mmcode
      .split('')
      .splice(0, 3)
      .join('');
    reqData.asset.modelCode = reqData.asset.mmcode
      .split('')
      .splice(3, 7)
      .join('');
    reqData.asset.newUsed = 'N';
    reqData.financeDetails = formData.financeDetails;
    reqData.financeIdentifiers = { preApprovalId: formData.preApprovalId };
    reqData.expenses = formData.expenses;
    reqData.customerProfile.bankingDetails = {
      finantialInstitutionCode: data.current_bank_personal_bank,
      accountType: data.account_type,
    };
    reqData.customerProfile.occupation = {
      occupationTypeCode: data.occupation,
      industryTypeCode: data.industry,
      employersName: data.name_of_employer,
      yearsAtWork: data.years_at_work,
      monthsAtWork: data.months_at_work,
    };
    reqData.customerProfile.finantialInstitutionCode =
      data.current_bank_personal_bank;

    console.log('LOG:', reqData.customerProfile);

    reqData.customerProfile.maritalInformation = {
      maritalStatus: reqData.customerProfile.maritalStatus,
      maritalContractCode: reqData.customerProfile.maritalContractCode,
    };

    reqData.customerProfile.residentialAddress.careOfAddressLine =
      reqData.customerProfile.residentialAddress.street;

    reqData.customerProfile.residentialAddress.yearsAtResidence =
      reqData.customerProfile.residentialAddress.durationYear;

    reqData.customerProfile.residentialAddress.monthsAtResidence =
      reqData.customerProfile.residentialAddress.durationMonth;

    reqData.customerProfile.postalAddress.careOfAddressLine =
      reqData.customerProfile.postalAddress.postalLine1;

    reqData.dealerExtras = [{ amount: '1207.5', code: 'IFC' }];

    //remove last responce
    let curr = formData;
    delete curr.financeResponse;

    console.log('Part 5:', reqData);

    setFormData(curr);

    const contact = {
      email: formData.customerProfile.contactMethod.email,
      province: data.select_province,
    };

    // Add the dealer property with dynamic province name
    const dealerPropertyName = `dealer_${data.select_province.toLowerCase().replace(/ /g, '_')}`;
    contact[dealerPropertyName] = data.preferred_suzuki_dealer_dealership;

    try {
      const res = await axios.post(
        'https://us-central1-fasttrack-client.cloudfunctions.net/api/contact',
        contact,
      );
      console.log('Contact response:', res);
    } catch (error) {
      console.log(error);
    }

    sendPreApprovalRequest(reqData)
      .then((res) => {
        console.log(res);
        setLoading(false);
        setFormData((curr) => {
          if (res.fieldErrors.length > 1) {
            return {
              ...curr,
              fieldErrors: res.fieldErrors,
            };
          } else if (res.financeIdentifiers.applicationStatus === 'R') {
            return {
              ...curr,
              fieldErrors: res.fieldErrors,
              referredResponse: true,
              referenceNumber: res.financeIdentifiers.referenceNumber,
            };
          } else {
            return {
              ...curr,
              referenceNumber: res.financeIdentifiers.referenceNumber,
            };
          }
        });
        setStepNumber((curr) => {
          return curr + 1;
        });
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
        setError(true);
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormSection>
        <FormHalfCol>
          <Select
            register={register}
            name="select_province"
            label="Select Province"
            errorMessage={errors.select_province?.message}
            options={provinces}
            setValue={setSelectedProvince}
            required
          />
          {selectedProvince && (
            <Select
              register={register}
              name="preferred_suzuki_dealer_dealership"
              label="Preferred Suzuki Dealer/dealership"
              errorMessage={errors.preferred_suzuki_dealer_dealership?.message}
              options={dealersByProvince[selectedProvince] || {}}
              required
            />
          )}
          <FinancialInstitutionSelect
            register={register}
            label="Current bank/personal bank"
            errorMessage={errors.current_bank_personal_bank?.message}
            required
          />
        </FormHalfCol>
        <FormHalfCol>
          <Select
            register={register}
            label="Account Type"
            errorMessage={errors.account_type?.message}
            options={{ S: 'Savings', C: 'Cheque', T: 'Transmission' }} //
            required
          />
        </FormHalfCol>
      </FormSection>
      <FormSection>
        <FormHalfCol>
          <Select
            register={register}
            label="Occupation"
            errorMessage={errors.occupation?.message}
            // options={{ CR00: 'Creative', CR01: 'Actor' }}
            options={occupations}
            required
          />
          <Select
            register={register}
            label="Industry"
            errorMessage={errors.industry?.message}
            // options={{ 701: 'Entertainment' }}
            options={formattedEmployerCodes}
            required
          />
          <Input
            label="Name of Employer"
            register={register}
            errorMessage={errors.name_of_employer?.message}
            required
          />
        </FormHalfCol>
        <FormHalfCol>
          <Input
            type="number"
            label="Years at Work"
            register={register}
            errorMessage={errors.years_at_work?.message}
            required
          />
          <Input
            type="number"
            label="Months at Work"
            register={register}
            errorMessage={errors.months_at_work?.message}
            required
          />
        </FormHalfCol>
      </FormSection>
      <div className="flex justify-center mt-16 w-full">
        <Input type="submit" label="Next" />
      </div>
    </form>
  );
};

export default VehiclePart5;
